import { Image } from 'components';
import { useAnalytics } from 'contexts/Analytics/Analytics';
import { resolveKromaticSiteUrl } from 'helpers';

// Owned download funnel for The Real Startup Book. resolveKromaticSiteUrl
// rewrites the host per runtime origin: staging.kromatic.com -> staging,
// every other host (prod, www, local, previews) -> prod.
const RSB_DOWNLOAD_URL = 'https://kromatic.com/download/the-real-startup-book';

export default function RsbCta() {

    const analytics = useAnalytics();
    const destinationUrl = resolveKromaticSiteUrl(RSB_DOWNLOAD_URL);

    function handleClick() {
        void analytics.trackActionEvent('rsb_cta_clicked', {
            destination_url: destinationUrl,
            resource_id: 'rsb_finish_cta',
            resource_type: 'ad',
            source: 'finish_cta',
        });
    }

    return (
        <div className="ps-lg-3 ps-xl-5">
            <a
                aria-label="Download The Real Startup Book — free"
                className="finish-rsb-cta card"
                data-testid="finish-rsb-cta-link"
                href={destinationUrl}
                onClick={handleClick}
                rel="noreferrer"
                target="_blank"
            >
                <div className="row g-0">
                    <div className="col-12 col-md-5">
                        <div className="finish-rsb-cta__visual">
                            <Image
                                alt="A stack of The Real Startup Book, 2nd Edition"
                                className="finish-rsb-cta__cover"
                                path="rsb-book-stack.webp"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-7">
                        <div className="finish-rsb-cta__content p-4">
                            <h4 className="card-title text-black mb-3">
                                Go deeper. Get The Real Startup Book — free.
                            </h4>
                            <p className="card-text text-muted mb-4">
                                The framework behind this tool, from 52 entrepreneurs. Download your free copy.
                            </p>
                            <span className="finish-rsb-cta__button">Download the book</span>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );

}
